import React from 'react'
import { Form } from 'react-bootstrap'
interface PropsType {
    lable: string
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
    name: string
    value: boolean | undefined
}
const SwitchButton = ({ lable, onChange, name, value }: PropsType) => {
    return (
        <Form.Check
            type="switch"
            id="custom-switch"
            label={lable}
            onChange={onChange}
            name={name}
            checked={value}
        />
    )
}

export default SwitchButton
